import React, { ReactElement } from 'react'
import { Select, SelectProps } from '../../../../React/Common/Components/Selects'
import { SelectOptionValues } from '../../../../React/Common/Components/Selects/Types'

export const OutlinedSelect = <T extends SelectOptionValues>(props: SelectProps<T>): ReactElement => (
    <Select
        {...props}
        containerClassName={`${props.containerClassName} outlined-select`}
        popoverClassName='outlined-select-popper'
        variant='outlined'
    />
)
